const CART_UPDATE_EVENT = 'cart:update';
const HIDE_DELAY = 2800;
const EXIT_DELAY = 240;

let toast;
let hideTimer;
let exitTimer;

function createToast() {
  const element = document.createElement('div');
  element.className = 'fumee-cart-feedback';
  element.setAttribute('role', 'status');
  element.setAttribute('aria-live', 'polite');
  element.setAttribute('aria-atomic', 'true');
  element.hidden = true;
  element.innerHTML = `
    <span class="fumee-cart-feedback__mark" aria-hidden="true"></span>
    <span class="fumee-cart-feedback__copy">
      <strong>Added to cart</strong>
      <span>Your scent is in the cart.</span>
    </span>
    <a class="fumee-cart-feedback__link" href="/cart">View cart</a>
  `;

  document.body.appendChild(element);
  return element;
}

function getToast() {
  if (!toast) {
    toast = createToast();
  }

  return toast;
}

function hideToast() {
  const element = getToast();
  element.classList.remove('is-visible');
  element.classList.add('is-leaving');

  window.clearTimeout(exitTimer);
  exitTimer = window.setTimeout(() => {
    element.hidden = true;
    element.classList.remove('is-leaving');
  }, EXIT_DELAY);
}

function showToast() {
  const element = getToast();

  window.clearTimeout(hideTimer);
  window.clearTimeout(exitTimer);

  element.hidden = false;
  element.classList.remove('is-visible', 'is-leaving');
  element.getBoundingClientRect();
  element.classList.add('is-visible');

  hideTimer = window.setTimeout(hideToast, HIDE_DELAY);
}

document.addEventListener(CART_UPDATE_EVENT, (event) => {
  const data = event.detail?.data;

  if (data?.source !== 'product-form-component') return;
  if (data?.didError === true) return;

  showToast();
});
